import { ERC20ABI } from '../ABI/ABI';
import { readContractData } from './contractInstance';
import { waitForSuccessfulTransactionReceipt } from './transactionReceipt';

/** Read current ERC-20 allowance (owner → spender). */
export async function readTokenAllowance(tokenAddress, owner, spender) {
    const allowance = await readContractData(tokenAddress, ERC20ABI, 'allowance', [
        owner,
        spender,
    ]);
    return allowance ?? 0n;
}

/**
 * Ensures allowance is at least `requiredAmount` by approving exactly that amount
 * (not unlimited). Standard ERC-20 approve sets allowance to `requiredAmount`.
 */
export async function ensureExactTokenAllowance({
    writeContractAsync,
    tokenAddress,
    spender,
    owner,
    requiredAmount,
    chainId,
}) {
    if (typeof requiredAmount !== 'bigint') {
        throw new Error('Approval amount must be a bigint.');
    }
    const required = requiredAmount;
    if (required <= 0n) {
        throw new Error('Approval amount must be greater than zero.');
    }

    const current = await readTokenAllowance(tokenAddress, owner, spender);
    if (current >= required) {
        return current;
    }

    const txHash = await writeContractAsync({
        address: tokenAddress,
        abi: ERC20ABI,
        functionName: 'approve',
        args: [spender, required],
        chainId,
    });
    await waitForSuccessfulTransactionReceipt(txHash);

    const updated = await readTokenAllowance(tokenAddress, owner, spender);
    if (updated < required) {
        throw new Error(
            'Token approval did not complete. Confirm the transaction and try again.',
        );
    }
    return updated;
}
